import { Cohort } from '@afterpaytouch/portal-api/types'

const COHORT_TAGS: Record<Cohort, string> = {
  [Cohort.CashOnly]: 'cash-only',
  [Cohort.APOnly]: 'ap-only',
  [Cohort.NetNew]: 'net-new',
}

export interface CheckoutJourneyTagValues {
  merchantId?: string | number | null
  country?: string | null
  cohort?: Cohort
  initial?: {
    token?: string
    isIframe?: boolean
    isWindowed?: boolean
  }
}

interface CheckoutJourneyTagContext extends CheckoutJourneyTagValues {
  existingTags?: readonly string[]
}

type CheckoutJourneyTag = readonly [key: string, value: string | number]

export const getCheckoutJourneyTags = ({ merchantId, country, cohort, existingTags = [], initial }: CheckoutJourneyTagContext): CheckoutJourneyTag[] => {
  const hasCheckoutToken = initial?.token != null && initial.token !== ''
  const values = {
    merchantId,
    country,
    windowType: !hasCheckoutToken ? undefined : initial?.isIframe === true ? 'iframe' : initial?.isWindowed === true ? 'popup' : 'redirect',
    cohort: cohort === undefined ? undefined : COHORT_TAGS[cohort],
  }

  return Object.entries(values).flatMap(([key, value]) =>
    value == null || value === '' || existingTags.some((tag) => tag.startsWith(`${key}:`)) ? [] : [[key, value] as const]
  )
}
